module.exports = __webpack_public_path__ + "img/ttshop_dfh.a91dba1c.svg";